import { useState } from "react";
import { useUser } from "../../../context/UserContext";
import { updateDocumentFirebase } from "../../../services/data-firebase"; // Asegúrate de importar la función correcta

export default function ModalFeedBack({ setserviceSelect, setShowModalFeedBack }) {
  const { user } = useUser(); // Accede a los datos del usuario desde el contexto
  console.log(user, 'from modal feedback');

  // Estado para los mensajes del chat
  const [messages, setMessages] = useState(user.services?.[0]?.chats || []);
  const [newMessage, setNewMessage] = useState("");

  // Función para enviar un mensaje
  const sendMessage = async () => {
    if (newMessage.trim() === "") return; // Evita enviar mensajes vacíos

    try {
      // Crear un nuevo mensaje
      const message = { text: newMessage, sender: "padre" };

      // Actualizar el estado `messages`
      setMessages((prevMessages) => [...prevMessages, message]);

      // Limpiar el input después de enviar el mensaje
      setNewMessage("");

      // Guardar los cambios en Firebase
      await handleSave(message);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSave = async (message) => {
    try {
      // Crear una copia del array `services` para mantener los datos existentes
      const updatedServices = [...user.services];
  
      // Actualizar el array `chats` dentro del primer elemento de `services`
      updatedServices[0] = {
        ...updatedServices[0], // Mantén todos los datos del primer servicio
        chats: [...updatedServices[0].chats, message], // Actualiza `chats` agregando el nuevo mensaje
      };
  
      // Actualizar el array `services` completo en Firebase
      await updateDocumentFirebase('madre', user.idFirestore, {
        services: updatedServices, // Actualiza todo el array `services`
      });
    } catch (error) {
      console.error("Error al actualizar la información:", error);
      alert("Hubo un error al guardar los cambios.");
    }
  };

  // Función para cerrar el modal y guardar los cambios
  const closeModalFeedBack = async () => {
    setShowModalFeedBack(null); // Cierra el modal
  };

  return (
    <div className="fixed bottom-4 bg-white shadow-lg rounded-lg overflow-hidden flex flex-col">
      {/* Encabezado del chat */}
      <div className="flex justify-between items-center p-4 bg-pink-500 text-white">
        <h2 className="text-lg font-semibold">Deja tu comentario sobre la niñera</h2>
        <button
          onClick={closeModalFeedBack}
          className="p-2 rounded-full hover:bg-pink-600 transition-colors duration-200"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      {/* Cuerpo del chat */}
      <div className="flex-1 p-4 overflow-y-auto bg-gray-50">
        <div className="space-y-4">
          {/* Mensajes del chat */}
          {messages.map((msg, index) => (
            <div key={index} className="flex justify-start">
              <div className="bg-gray-200 p-3 rounded-lg max-w-xs">
                {msg.text}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Input para enviar mensajes */}
      <div className="p-4 bg-white border-t">
        <div className="flex items-center">
          <input
            type="text"
            placeholder="Escribe un mensaje..."
            className="flex-1 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-pink-500"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          />
          <button
            className="ml-2 p-2 bg-pink-500 text-white rounded-full hover:bg-pink-600 transition-colors duration-200"
            onClick={sendMessage}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="22" y1="2" x2="11" y2="13" />
              <polygon points="22 2 15 22 11 13 2 9 22 2" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}